import { AnyAction, MiddlewareAPI } from '@reduxjs/toolkit';
import { Dispatch } from 'react';
import { commonSlice } from 'src/store/commonPart/slice';
import { currentUserSlice } from 'src/store/user/slice';
import { SafeAnyType } from 'src/utils/safeAny';

const okActions = [
  commonSlice.actions.getConfigurationOk.type,
  commonSlice.actions.getCurrentPartnerOk.type,
  commonSlice.actions.getCurrencyListOk.type,
  currentUserSlice.actions.getCurrentUserOk.type,
];

const errorActions = [
  commonSlice.actions.getConfigurationError.type,
  commonSlice.actions.getCurrentPartnerError.type,
  commonSlice.actions.getCurrencyListError.type,
  currentUserSlice.actions.getCurrentUserError.type,
];

export const percentageLoadingMiddleware =
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  (store: MiddlewareAPI<SafeAnyType>) => (next: Dispatch<SafeAnyType>) => (action: AnyAction) => {
    const result = next(action);

    if (okActions.includes(action.type)) {
      const currentPercent = store.getState().common.percentLoading;

      const MAX_PERCENT = 100;

      store.dispatch(
        commonSlice.actions.changePercentage({
          percent: Math.min(currentPercent + MAX_PERCENT / okActions.length, MAX_PERCENT),
        })
      );
    } else if (errorActions.includes(action.type)) {
      store.dispatch(commonSlice.actions.changePercentage({ error: action.payload }));
    }
    return result;
  };
